var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-link',{staticClass:"btn-social",class:{ onlyIcon: _vm.onlyIcon },on:{"click":_vm.action}},[_c('b-img',{staticClass:"w-24",class:{ onlyIcon: _vm.onlyIcon, 'btn-social-margin': !_vm.onlyIcon },attrs:{"src":_vm.getImage,"alt":_vm.$t('continueWithFacebook')}}),(!_vm.onlyIcon)?[_vm._v(" "+_vm._s(_vm.$t("continueWithFacebook"))+" ")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }